import { render, staticRenderFns } from "./InstanceDialog.vue?vue&type=template&id=13745e64&"
import script from "./InstanceDialog.vue?vue&type=script&lang=js&"
export * from "./InstanceDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports